import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ILabel } from '../models/labels.interface';
import { LabelsService } from 'src/app/services/labels.service';
import {
  Observable,
  Subject,
  debounceTime,
  distinctUntilChanged,
  forkJoin,
  of,
  switchMap,
} from 'rxjs';
import { MapService } from 'src/app/services/map.service';
import { Router } from '@angular/router';
import { IRangeDate } from '../models/graph-data.interface';
import { TreeviewItem, TreeviewConfig } from '@ash-mezdo/ngx-treeview';
import { WellsService } from 'src/app/services/wells.service';
import {
  allGraphs,
  geoJsonType,
  imageType,
  model3dType,
} from './models/graph-type.constants';
import { LoadingService } from 'src/app/services/loading.service';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollCustomEvent } from '@ionic/angular';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, OnChanges {
  @Input() labelList: ILabel[] = [];
  @Input() showMenu!: boolean;
  @Input() showGraph!: boolean;
  @Input() showDatePicker!: boolean;
  @Input() rangeDate!: IRangeDate;
  @Input() periodDate!: Date;
  @Input() wellList: any[] = [];
  @Input() treeList: any[] = [];
  @Input() timeRangeA!: boolean;
  @Input() timeMomentA!: boolean;
  @Output() closeEvent = new EventEmitter<boolean>();
  @Output() timeRange = new EventEmitter<boolean>();
  @Output() timeMoment = new EventEmitter<boolean>();
  @Output() closeEventRange = new EventEmitter<boolean>();
  @Output() graphEvent = new EventEmitter<boolean>();
  @Output() fullScreenGraphs = new EventEmitter<boolean>();
  @Output() searchZone = new EventEmitter<boolean>();
  @Output() labelGraph = new EventEmitter<ILabel[]>();
  @Output() minDateEvent = new EventEmitter<Date>();
  @Output() maxDateEvent = new EventEmitter<Date>();
  @Output() dmuSelected = new EventEmitter<string>();
  @Output() periodDateC = new EventEmitter<{ start: Date; end: Date }>();
  @Output() minDateEventC = new EventEmitter<Date>();
  @Output() maxDateEventC = new EventEmitter<Date>();
  @Output() timeRangeC = new EventEmitter<boolean>();
  @Output() timeMomentC = new EventEmitter<boolean>();
  @Output() layersSelected = new EventEmitter<any[]>();
  @Output() layersSelectedCompare = new EventEmitter<any[]>();

  @Output() minDateEventRange = new EventEmitter<any>();
  @Output() maxDateEventRange = new EventEmitter<any>();
  

  @ViewChild('t1') tooltip!: NgbTooltip;
  public showFilures: boolean = false;
  public showPresionesProductor: boolean = false;
  public showConnectivities: boolean = false;
  public showDMUs: boolean = true;
  public openSearch: boolean = false;
  public openDate: boolean = true;
  public openCompare: boolean = false;
  public existCompare: boolean = false;
  public show3D: boolean = false;
  public showTooltip = false;
  private isTooltipOpen = false;
  public config = TreeviewConfig.create({
    hasAllCheckBox: true,
    hasFilter: true,
    hasCollapseExpand: true,
    decoupleChildFromParent: false,
  });
  labelsSave: any[] = [];
  items: any;
  valores: any[] = [];
  valoresComp: any[] = [];
  labelsPrev: TreeviewItem[] = [];
  showPatrones: boolean = false;
  searchList: any;
  searchTerm$ = new Subject<string>();
  searchDelay = 1000;
  pointSelected!: string;
  applied: any[] = [];
  isOpen: boolean = false;
  showRemoveCompare: boolean = false;
  compareLabels: any[] = [];
  cmpList: any;
  public startDate: Date | undefined;
  public endDate: Date | undefined;
  public rangeDateCompare = {
    start: new Date(),
    end: new Date(),
  };

  public periodDateCompare = new Date();
  public minValue = new Date(
    new Date().getFullYear() - 1,
    new Date().getMonth(),
    new Date().getDate()
  );
  @Input() minValueRange: Date = new Date(
    new Date().getFullYear() - 1,
    new Date().getMonth(),
    new Date().getDate()
  );

  constructor(
    private _labelsService: LabelsService,
    public _mapService: MapService,
    private _router: Router,
    private wellService: WellsService,
    public loadingService: LoadingService,
  ) {
    this.searchTerm$
    _mapService.temporalSerie$.subscribe(((data) => {
      if(data.show && data.dmu){
        this.showGraph = true;
        const root = [-3];
        this.labelGraph.emit(this.labelsSave[root[0] * -1]);
        this.graphEvent.next(true)
      }
    }))
  }

  openSlider(item) {
    let timeRange: boolean = false;
    let timeMoment: boolean = false;
    for (const tree of this.items) {
      const treeResults = this.hasIndeterminateTime(tree);

      if (treeResults.hasTimeRange) {
        timeRange = true;
      }

      if (treeResults.hasTimeMoment) {
        timeMoment = true;
      }
    }
    this.timeRange.next(timeRange);
    this.timeMoment.next(timeMoment);
  }

  openTooltip(tooltip: NgbTooltip, content: string) {
    if (tooltip.isOpen()) {
      tooltip.close();
    } else {
      tooltip.open({ greeting: content });
      this.addOutsideClickListener();
    }
  }

  private addOutsideClickListener() {
    setTimeout(() => {
      document.addEventListener('click', this.closeTooltipOutsideClick);
    });
  }

  private closeTooltipOutsideClick = (event: Event) => {
    if (this.isTooltipOpen && !this.isClickInsideTooltip(event)) {
      this.tooltip.close();
      this.isTooltipOpen = false;
      document.removeEventListener('click', this.closeTooltipOutsideClick);
    }
  };

  private isClickInsideTooltip(event: Event): boolean {
    const tooltipContainerId = this.tooltip.container;
    const tooltipContainer = document.getElementById(tooltipContainerId);
    
    return tooltipContainer && tooltipContainer.contains(event.target as Node) as any;
  }

  
  closeTooltip(tooltip) {
    tooltip.close();
  }

  hasIndeterminateTime(tree: any): {
    hasTimeRange: boolean;
    hasTimeMoment: boolean;
  } {
    let result = { hasTimeRange: false, hasTimeMoment: false };

    if (tree.indeterminate === true || tree.internalChecked) {
      if (tree.text.includes('Time Range')) {
        result.hasTimeRange = true;
      }

      if (tree.text.includes('Time Moment')) {
        result.hasTimeMoment = true;
      }
    }

    if (tree.internalChildren && tree.internalChildren.length > 0) {
      for (const child of tree.internalChildren) {
        const childResults = this.hasIndeterminateTime(child);
        result.hasTimeRange = result.hasTimeRange || childResults.hasTimeRange;
        result.hasTimeMoment =
          result.hasTimeMoment || childResults.hasTimeMoment;
      }
    }

    return result;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['treeList']?.previousValue ||
      changes['wellList']?.previousValue
    ) {
      this.getMasterTree();
      this.items = this.labelsPrev;

      this.wellService.search('').subscribe((reponse) => {
        this.searchList = reponse;
      });
    } else if (changes['showGraph']?.previousValue == true) {
      this.toggleCheckedState(this.items.find((item) => item.value == -3));
      this.valores = this.valores.filter((value) => value != -3);
    }
  }

  toggleCheckedState(item: any) {
    item.checked = false;
  }

  ngOnInit() {
    // this.getMasterTree();
    // this.items = this.labelsPrev;
  }

  onInputChange(event): void {
    const searchTerm = event.target.value;
    this.searchTerm$.next(searchTerm);
  }
  performSearch(search: string) {
    const searchTerm = search;
    this.loadingService.show();
    this.getSearchDMU(searchTerm).subscribe((result) => {
      this.searchList = result;
      this.loadingService.hide();
    });
  }

  getSearchDMU(text: string) {
    return this.wellService.search(text);
  }

  setCenterMap(longitude, latitude, type, name) {
    const zoomLevel = type == 'FIELD' ? 10 : 18;
    this._mapService.setCenterMap(latitude, longitude, zoomLevel);
    this.resize();
    this.pointSelected &&
      this.changeUnclusteredPointColorByName(
        this._mapService.map,
        'dmu-data',
        this.pointSelected,
        '#BE0BE3'
      );

    this.changeUnclusteredPointColorByName(
      this._mapService.map,
      'dmu-data',
      name,
      'red'
    );

    this.pointSelected = name;
    this.toggleDate();
  }

  changeUnclusteredPointColorByName(map, sourceId, targetName, newColor) {
    const source = map.getSource(sourceId);
    if (!source) return;

    const features = source._data.features;
    for (const feature of features) {
      if (feature.properties.name === targetName) {
        feature.properties.color = newColor; // Agrega una propiedad 'color' al objeto con el nuevo color
      }
    }

    // Actualiza la fuente con los cambios
    source.setData(source._data);
  }

  getGraphData(graphType: string) {
    this._mapService.setVisibilityLayer(this.showFilures, 'failures');
    this._mapService.setVisibilityLayer(this.showDMUs, 'dmu');
    const periodDate = this.periodDate?.toISOString().split('T')[0];
    const rangeDate = {
      // start_date: this.rangeDate?.start?.toISOString().split('T')[0],
      // end_date: this.rangeDate.end?.toISOString().split('T')[0],
      period_date: periodDate
        ? periodDate
        : new Date().toISOString().split('T')[0],
    };
    const labelsIds = this.labelList
      .filter((label) => label.selected && label.graphType == graphType)
      .map((label) => label.id);

    if (labelsIds.length > 0) {
      this.loadingService.show();
      this._labelsService
        .getGraphData(labelsIds.toString(), rangeDate)
        .subscribe((graphs) => {
          if (graphType == 'spatial') {
            this._mapService.addImage(graphs);
          } else {
            this._router.navigate(['/graph'], {
              state: { graphs, labelsIds, rangeDate: this.rangeDate },
            });
          }
          this.loadingService.hide();
        });
    }
  }

  closeMenu() {
    this.closeEvent.next(false);
  }

  cancel(graphType) {
    this._mapService.removeAllLayer();
    this.labelList = this.labelList.map((label) => {
      if (label.graphType == graphType) {
        label.selected = false;
      }
      return label;
    });
  }

  isShowCancelButton(graphType) {
    return this.labelList.some(
      (label) => label.selected && label.graphType == graphType
    );
  }

  validateMaxSelected(graphType) {
    return (
      this.labelList.filter(
        (label) => label.selected && label.graphType == graphType
      ).length >= 10
    );
  }

  resize() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }

  private oldSelectedItems: any[] = [];
  private newSelectedItems: any[] = [];
  private previousPeriodDate!: string;
  private previousStartDate!: string;
  private previousEndDate!: string;

  selectedGraph(compare: boolean = false, compareId?): void {
    let toEndpoint: any = [];
    let root: any = [];
    let generator: any[] = [];
    if(compare){
      generator = this.valoresComp;
    }else{
      generator = this.valores;
    }
    
    if (generator.length <= 30) {
      for (let v of generator) {
        if (v >= 1) {
          const isOld = this.oldSelectedItems.includes(v);

        // If it's not in the old selected items, it's new
        if (!isOld) {
          this.newSelectedItems.push(v);
        }
        // Add it to the toEndpoint array
        toEndpoint.push(v);
        } else if (v < 0) {
          root.push(v);
        }
        
      }
  
      this.oldSelectedItems = this.oldSelectedItems.concat(this.newSelectedItems);
      this.oldSelectedItems = this.oldSelectedItems.filter(item => toEndpoint.includes(item));
      this.cmpList = this.compareLabels.filter((label) => this.valores.includes(label.id));
      if(this.cmpList.length>0){
        this.existCompare = true;
      }else{
        this.cmpList = null;
        this.existCompare = false;
      }      
      
      if(!compare){
        this.showPresionesProductor = generator.includes(0.8) ? true : false;
        this.showPatrones = generator.includes(0.9) ? true : false;
        this.showDMUs = generator.includes(0.1) ? true : false;
      }
       
      if (root.length > 0) {
        this.labelGraph.emit(this.labelsSave[root[0] * -1]);
        this.graphEvent.next(true);
        this.closeEventRange.emit(false);
        const width = window.innerWidth;
        this.fullScreenGraphs.next(width < 1200 ? true : false);
        this.dmuSelected.next('')
        this.resize();
      }
      this._mapService.setVisibilityLayer(this.showDMUs, 'dmu');
      this._mapService.setVisibilityLayer(this.showDMUs, 'cluster-count');
      this._mapService.setVisibilityLayer(this.showDMUs, 'unclustered-point');
      this._mapService.setVisibilityLayer(this.showFilures, 'failures');
      
      this._mapService.setVisibilityLayer(this.showPatrones, 'patrones');

      const periodDate = compare ? this.periodDateCompare?.toISOString().split('T')[0] : this.periodDate?.toISOString().split('T')[0];
      const currentStartDate = compare ? this.rangeDateCompare?.start?.toISOString().split('T')[0] || new Date().toISOString().split('T')[0] :  this.rangeDate?.start?.toISOString().split('T')[0] || new Date().toISOString().split('T')[0];
      const currentEndDate = compare ? this.rangeDateCompare?.end?.toISOString().split('T')[0] || new Date().toISOString().split('T')[0] : this.rangeDate?.end?.toISOString().split('T')[0] || new Date().toISOString().split('T')[0];
      const rangeDate = {
        start_date: currentStartDate
        ? currentStartDate
        : new Date().toISOString().split('T')[0],
        end_date: currentEndDate
        ? currentEndDate
        : new Date().toISOString().split('T')[0],
        period_date: periodDate
          ? periodDate
          : new Date().toISOString().split('T')[0],
      };
      // this._mapService.removeAllImages();
      // this._mapService.removeAllBubbles();
      // this._mapService.removeAllDonuts();

      if (compare) {
        if(this.showRemoveCompare){
          //this.removeCompareLayer(true, compareId);
          this._mapService.removeAllLayer(compare);
        }
        //toEndpoint = [compareId];
        this.showRemoveCompare = true;
      }

      this.previousPeriodDate = this.previousPeriodDate ? this.previousPeriodDate : rangeDate.period_date;
      this.previousStartDate = this.previousStartDate ? this.previousStartDate : rangeDate.start_date;
      this.previousEndDate = this.previousEndDate ? this.previousEndDate : rangeDate.end_date;

      if(this.previousPeriodDate != rangeDate.period_date || this.previousEndDate != rangeDate.end_date || this.previousStartDate != rangeDate.start_date){
        this.newSelectedItems = this.oldSelectedItems;          
      }
      this._mapService.removeAllLayer(compare);
      this.showPresionesProductor && this._mapService.addPresiones3();
      if (toEndpoint.length > 0) {
        try {
          this.loadingService.show();
          this._labelsService
            .getGraphData(toEndpoint.toString(), rangeDate)
            .subscribe((graphs) => {
              this.newSelectedItems = [];
              this.previousPeriodDate = rangeDate.period_date;
              this.previousEndDate = rangeDate?.end_date;

              compare ?  this.maxDateEventRange.emit(rangeDate) : this.minDateEventRange.emit(rangeDate);
              
              this.applied = toEndpoint;
              let spatial = graphs.filter(
                (obj) => obj?.type && allGraphs.includes(obj.type)
              );
              let series = graphs.filter(
                (obj) => obj?.type && ['temporal_mosaico'].includes(obj.type)
              );
              if (spatial.length > 0) {
                if(compare){
                  this.layersSelectedCompare.emit(spatial);                  
                }else{
                  this.layersSelected.emit(spatial);
                }                
                const groupedGraphs = graphs.reduce(
                  (acc, objeto) => {
                    if (imageType.includes(objeto.type)) {
                      acc.images.push(objeto);
                    } else if (objeto.type === 'donut') {
                      acc.donut.push(objeto);
                    } else if (geoJsonType.includes(objeto.type)) {
                      acc.geojson.push(objeto);
                    } else if (model3dType.includes(objeto.type)) {
                      acc.model3d.push(objeto);                        
                    }
                    return acc;
                  },
                  { images: [], donut: [], geojson: [], model3d: [] }
                );
                try {
                  this._mapService.errors = []
                  const { images, donut, geojson, model3d } = groupedGraphs;
                  geojson.length > 0 &&
                    this._mapService.addGeoJson(geojson, compare);
                  images.length > 0 &&
                    this._mapService.addImage(images, compare);
                  donut.length > 0 && this._mapService.addDonut(donut, compare);
                  model3d.length > 0 && this._mapService.add3dgraph(model3d, compare);

                  if( this._mapService.errors.length > 0){
                    this._mapService.presentToast("No hay datos en este rango de fechas ,  para estas graficas ("+this._mapService.errors.join(' - ')+" ) ") 
                  }
                } catch (error) {
                  console.log("e", error);                    
                }
              }
              if (series.length > 0) {
                this.graphEvent.next(true);
                this.resize();
              }
              if (series.length > 0) {
                this.graphEvent.next(true);
                this.resize();
                
              }
              this.loadingService.hide();
            });
        } catch (error) {}
      }else{
        this.timeMomentC.next(false);
        this.timeRangeC.next(false);
      }
    } else {
      this.isOpen = true;
    }
  }

  removeCompareLayer(compare: boolean = false, compareId?){
    this._mapService.removeCompareLayers(compareId);
    this.showRemoveCompare = false;
    this.timeMomentC.next(false);
    this.timeRangeC.next(false);
    //this.removeCompare();
  }

  removeCompare(){
    this._mapService.removeAllLayer(true)
    this._mapService.compare.remove();
    this.showRemoveCompare = false;
    this._mapService.showCompare = false;
    this.valoresComp = [];
    this.timeMomentA = false;
    this.timeRangeA = false;
    this.timeMomentC.next(false);
    this.timeRangeC.next(false);
    this.layersSelectedCompare.emit([]);
  }

  cleanMap(){
    this._mapService.removeAllLayer();
    this.layersSelected.emit([]);
  }

  onCheckboxChange(item: TreeviewItem) {
    // Cambia el estado de la casilla de verificación del nodo actual
    item.checked = !item.checked;

    // Recorre los nodos hijos (si los tiene) y establece el mismo estado
    if (item.children && item.children.length > 0) {
      item.children.forEach((child) => {
        child.checked = item.checked;
        // Si deseas que los cambios se propaguen a los hijos de forma recursiva,
        // puedes llamar a una función recursiva aquí.
        this.toggleChildren(child, item.checked);
      });
    }

    // Actualiza el estado de los nodos padres si es necesario
    this.updateParentNodes(item);
  }

  toggleChildren(item: TreeviewItem, isChecked: boolean) {
    // Función recursiva para cambiar el estado de los hijos de forma recursiva
    if (item.children && item.children.length > 0) {
      item.children.forEach((child) => {
        child.checked = isChecked;
        this.toggleChildren(child, isChecked);
      });
    }
  }

  updateParentNodes(item: any) {
    // Actualiza el estado de los nodos padres si todos sus hijos están marcados
    if (item.parent && item.parent instanceof TreeviewItem) {
      const parent = item.parent as TreeviewItem;
      const areAllChildrenChecked = parent.children.every(
        (child) => child.checked
      );
      parent.checked = areAllChildrenChecked;
      this.updateParentNodes(parent);
    }
  }

  getTextTooltip(item: TreeviewItem) {
    const description = this.findElementById(
      item.value,
      this.treeList
    )?.description;
    return description ? description : item.text;
  }

  findElementById(id: number, items: any[]): any | null {
    for (const item of items) {
      // Buscar en la propiedad "labels" del elemento
      const label = item.labels.find((labelItem) => labelItem.id === id);
      if (label) {
        return label;
      }

      // Si no se encuentra en "labels", buscar en los elementos hijos (si existen)
      if (item.children && item.children.length > 0) {
        const foundChild = this.findElementById(id, item.children);
        if (foundChild) {
          return foundChild;
        }
      }
    }

    return null; // Si no se encuentra el elemento con el ID especificado
  }

  getMasterTree() {
    this.labelsPrev = [];
    this.labelsPrev.push(
      new TreeviewItem({
        text: 'DMU (Pozos)',
        value: 0.1,
        checked: this.showDMUs,
      })
    );
 
    let indexer = 1;
    for (let tst of this.treeList) {
      let lid = tst.id;
      if (tst.visualization_type != null) {
        lid = tst.id * -1;
      }
      const i = new TreeviewItem({
        text: tst.name,
        value: lid,
        checked: false,
        collapsed: true,
        children: [],
      });
      this.labelsPrev.push(i);
      if (tst.children.length > 0) {
        this.getChildrenTree(tst.children, indexer, this.labelsPrev);
      }
      if (tst.labels.length > 0) {
        if (tst.visualization_type === null) {
          this.setTreeLabels(tst.labels, indexer, this.labelsPrev);
        } else {
          this.labelsSave[tst.id.toString()] = tst.labels;
        }
      }
      indexer++;
    }

    this.labelsPrev.push(
      new TreeviewItem({
        text: 'Patrones de inyección',
        value: 0.9,
        checked: this.showPatrones,
      })
    );

    this.labelsPrev.push(
      new TreeviewItem({
        text: 'Presiones productor',
        value: 0.8,
        checked: this.showPresionesProductor,
      })
    );
  }

  getChildrenTree(children, iterator, tree) {
    let indexer = 0;
    for (let tst of children) {
      let lid = tst.id;
      if (tst.visualization_type != null) {
        lid = tst.id * -1;
      }
      const i = new TreeviewItem({
        text: tst.name,
        value: lid,
        checked: false,
        collapsed: true,
        children: [],
      });
      
      
      if (null == tree[iterator].children) {
        tree[iterator].children = [i];
      } else {
        tree[iterator].children.push(i);
      }

      if (tst.children.length > 0) {
        this.getChildrenTree(tst.children, indexer, tree[iterator].children);
      }
      if (tst.labels.length > 0) {
        if (tst.visualization_type === null) {
          this.setTreeLabels(tst.labels, indexer, tree[iterator].children);
        } else {
          this.labelsSave[tst.id.toString()] = tst.labels;
        }
      }
      tree[iterator].correctChecked();
      indexer++;
    }
  }

  setTreeLabels(labels, iterator, tree) {
    for (let tst of labels) {
      const i = new TreeviewItem({
        text: tst.name,
        value: tst.id,
        checked: false,
        collapsed: true,
        children: [],
      });
      if (null == tree[iterator].children) {
        if(tst.filter_type){          
          this.compareLabels.push(tst);
        }
        tree[iterator].children = [i];
      } else {
        if(tst.filter_type){          
          this.compareLabels.push(tst);
        }        
        tree[iterator].children.push(i);
      }
      tree[iterator].correctChecked();
    }
  }

  toggleDate() {
    this.openDate = !this.openDate;
    if (this.openDate) {
      this.openSearch = false;
      this.openCompare = false;
    }
  }
  toggleSearch() {
    this.openSearch = !this.openSearch;
    if (this.openSearch) {
      this.openDate = false;
      this.openCompare = false;
    }
  }
  toggleCompare() {
    this.openCompare = !this.openCompare;
    if (this.openCompare) {
      this.openDate = false;
      this.openSearch = false;
    }
  }
  setRangeDate(event: Date, type = 'end') {
    type == 'start' ? (this.rangeDateCompare.start = event) : (this.rangeDateCompare.end = event);
    this.periodDateC.next(this.rangeDateCompare);
  }
  setTimeMomentDate(event: Date, type = 'end') {
    type == 'start' ? (this.periodDateCompare = event) : (this.rangeDateCompare.end = event);
    this.minDateEventC.next(this.periodDateCompare)
  }
  checkCompare(cmp, event){
    if(cmp.filter_type.includes("TIME_RANGE")){
      this.timeRangeA = event.detail.checked;
      this.timeRangeC.next(this.timeRangeA);
    }
    if(cmp.filter_type.includes("TIME_MOMENT")){
      this.timeMomentA = event.detail.checked;
      this.timeMomentC.next(this.timeMomentA);
    }
    if (event.detail.checked) {
      if(!this.valoresComp.includes(cmp.id)){
        this.valoresComp.push(cmp.id);
      }
    } else {
     let newArray = this.valoresComp.filter(function(el) {
        return el !== cmp.id;
      });
      this.valoresComp = newArray;    
    }
  }
  SelectedCompare(){
    this.selectedGraph(true);
  }

  onIonInfinite(ev) {
    setTimeout(() => {
      (ev as InfiniteScrollCustomEvent).target.complete();
    }, 500);
  }
  
}
